import { useTranslation } from '@frontend/i18n';
import { Heading, Tabs, Text } from '@frontend/design-system';

export const PanelTabs = () => {
  const { t } = useTranslation('schedule');

  return (
    <Tabs initialTab='notes'>
      <Tabs.Bar fullWidth>
        <Tabs.Tab id='notes'>{t('Notes')}</Tabs.Tab>
        <Tabs.Tab id='auto-messages'>{t('Auto Messages')}</Tabs.Tab>
        <Tabs.Tab id='forms'>{t('Forms')}</Tabs.Tab>
        <Tabs.Tab id='payments'>{t('Payments')}</Tabs.Tab>
      </Tabs.Bar>
      <Tabs.Panel controller='notes'>
        <Heading level={2}>Notes</Heading>
        <Text>
          I'm baby organic yuccie irony YOLO. Art party la croix pinterest heirloom synth kogi artisan mumblecore
          meggings leggings.
        </Text>
      </Tabs.Panel>
      <Tabs.Panel controller='auto-messages'>
        <Heading level={2}>Auto Messages</Heading>
        <Text>
          Fanny pack tacos letterpress squid. Health goth you probably haven't heard of them franzen banjo succulents
          organic fashion axe cornhole.
        </Text>
      </Tabs.Panel>
      <Tabs.Panel controller='forms'>
        <Heading level={2}>Forms</Heading>
        <Text>
          Tacos blog copper mug, affogato kombucha salvia offal literally pinterest scenester meh unicorn hella
          typewriter fashion axe.
        </Text>
      </Tabs.Panel>
      <Tabs.Panel controller='payments'>
        <Heading level={2}>Payments</Heading>
        <Text>Pabst blue ribbon glossier, hammock vape</Text>
      </Tabs.Panel>
    </Tabs>
  );
};
